import { Input } from "@chakra-ui/react";
import { useLayoutEffect } from "react";
import { RegisterOptions, useController } from "react-hook-form";
import { FLUSHED_FLOATING_INPUT_SX } from "definitions/constants/styling";
import { useFloatingField } from "./context";
import { sizeStyles } from "./sizeStyles";

type FloatingTextProps = {
  control: any;
  name: string;
  rules?: RegisterOptions;
  defaultValue?: any;
  type?: string;
  disabled?: boolean;
  readOnly?: boolean;
  onBlur?: () => void;
};

function FloatingText({
  control,
  name,
  rules,
  defaultValue,
  type,
  disabled,
  readOnly,
  onBlur: onBlurProp,
}: FloatingTextProps) {
  const { setHasValue, size } = useFloatingField();
  const { field } = useController({ control, name, rules, defaultValue });
  const styles = sizeStyles[size];
  const { onBlur: fieldOnBlur, ...restField } = field;

  useLayoutEffect(() => {
    setHasValue(!!field.value);
  }, [field.value, setHasValue]);

  return (
    <Input
      {...restField}
      id={name}
      type={type}
      disabled={disabled}
      readOnly={readOnly}
      height={styles.inputHeight}
      paddingTop={styles.textInputPaddingTop}
      fontSize={styles.fontSize}
      variant="unstyled"
      sx={FLUSHED_FLOATING_INPUT_SX}
      onBlur={() => {
        fieldOnBlur();
        onBlurProp?.();
      }}
    />
  );
}

export default FloatingText;
